/**
 * @file Agenda grid bar component.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { AfterViewInit, OnDestroy, ElementRef, NgZone } from '@angular/core';
import { GridBarBaseComponent } from '../grid-bar-base/grid-bar-base.component';
import { InputEntityComponent } from '../../base/inputs/input-entity/input-entity.component';
import { Router, NavigationEnd } from '@angular/router';
import * as moment from 'moment';
import { ExecutorsService } from '../executors.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
import { GridService } from '../grid.service';
import { UserService } from '../../user.service';
/** Agenda grid bar component. */
var AgendaGridBarComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaGridBarComponent, _super);
    /**
     * Constructs AgendaGridBarComponent.
     * @param configurationsService The configuration service to get the configuration of this component.
     * @param router The router to synchronize query parameters with component state.
     */
    function AgendaGridBarComponent(userService, executorsService, alertsService, elementRef, ngZone, router, eventsService, gridService) {
        var _this = _super.call(this, executorsService, alertsService, elementRef, ngZone, eventsService, gridService) || this;
        _this.userService = userService;
        _this.router = router;
        _this.gridService = gridService;
        return _this;
    }
    Object.defineProperty(AgendaGridBarComponent.prototype, "inputEntityFormat", {
        /**
         * The format of the InputEntityComponent.
         * We want also to filter on Resource.Finish.
         * @readonly
         * @type {*}
         */
        get: function () {
            var data = this.configuration.data;
            var firstName = data.fields.find(function (field) { return field.name === 'FirstName'; });
            var name = data.fields.find(function (field) { return field.name === 'Name'; });
            var prefix = data.fields.find(function (field) { return field.name === 'Prefix'; });
            var view = this.gridService.startDate.toDate();
            return {
                dataSource: data.dataSource,
                parameters: { view: view },
                entity: data.entity,
                fields: [firstName.name, name.name, prefix.name],
                displayFormat: "[" + name.name + "] ([" + firstName.name + "] [" + prefix.name + "])"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgendaGridBarComponent.prototype, "selectedResource", {
        /** Gets the key of the selected resource. The owner of the agenda. */
        get: function () {
            var params = JSON.parse(JSON.stringify(this.router.routerState.root.snapshot.queryParams).toLowerCase());
            if (params[AgendaGridBarComponent.resourceParam]) {
                return params[AgendaGridBarComponent.resourceParam].toUpperCase();
            }
            else {
                return this.userService.user.Resource_Oid;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgendaGridBarComponent.prototype, "items", {
        /** Create set of items. */
        get: function () {
            return this.gridService.level.formatter.barGridItems(this, this.gridService);
        },
        enumerable: true,
        configurable: true
    });
    /** Returns true if a GridItem represents the 'current hour' */
    AgendaGridBarComponent.prototype.isCurrentHour = function (item) {
        if (this.isToday(item.click.date)) {
            var now = moment();
            if (item.click.date <= now && moment(item.click.date).add(1, 'hours') > now) {
                return true;
            }
        }
        return false;
    };
    /** Lifecycle hook that is called after a component's view has been fully initialized. */
    AgendaGridBarComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.entitySelector.value) {
            window.setTimeout(function () {
                var params = JSON.parse(JSON.stringify(_this.router.routerState.root.snapshot.queryParams).toLowerCase());
                if (params[AgendaGridBarComponent.resourceParam]) {
                    _this.entitySelector.oid = params[AgendaGridBarComponent.resourceParam].toUpperCase();
                }
                else {
                    _this.entitySelector.value = _this.userService.user.Resource;
                }
            });
        }
        this.subscriptionPool.add(this.entitySelector.valueChange.subscribe(function (value) {
            if (!value) {
                var resource = _this.userService.user.Resource;
                if (!resource) {
                    return;
                }
                _this.entitySelector.value = resource;
            }
            var params = JSON.parse(JSON.stringify(_this.router.routerState.root.snapshot.queryParams).toLowerCase());
            var oid = _this.entitySelector.oid.toLowerCase();
            if (params[AgendaGridBarComponent.resourceParam] !== oid) {
                params[AgendaGridBarComponent.resourceParam] = oid;
                _this.router.navigate([], { queryParams: params });
            }
        }));
        this.subscriptionPool.add(this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                var params = JSON.parse(JSON.stringify(_this.router.routerState.root.snapshot.queryParams).toLowerCase());
                if (params[AgendaGridBarComponent.resourceParam]) {
                    var oid = params[AgendaGridBarComponent.resourceParam].toUpperCase();
                    if (oid !== _this.entitySelector.oid) {
                        _this.entitySelector.oid = oid;
                    }
                }
            }
        }));
    };
    /** Lifecycle hook that is called when the component is destroyed. */
    AgendaGridBarComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subscriptionPool = null;
    };
    /** Name of the selected resource query parameter. */
    AgendaGridBarComponent.resourceParam = 'resource';
    return AgendaGridBarComponent;
}(GridBarBaseComponent));
export { AgendaGridBarComponent };
